import React from 'react';
import {
  ChatWidgetContextProvider,
  MessageList,
} from 'features/nekst-widgets';
import ConversationsSidebar from './ConversationsSidebar';
import FullPageComposer from './FullPageComposer';

function ConversationArea() {
  return (
    <div className="flex flex-1 flex-col overflow-hidden min-w-0">
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 flex flex-col overflow-hidden max-w-[900px] mx-auto w-full">
          <MessageList />
        </div>
      </div>
      <div className="max-w-[900px] mx-auto w-full" style={{ padding: '0 16px 16px' }}>
        <FullPageComposer />
        <p style={{ fontSize: '12px', color: '#9ca3af', textAlign: 'center', padding: '4px 0' }}>
          Nekst AI can make mistakes. Consider checking important information.
        </p>
      </div>
    </div>
  );
}

export default function LlmChatPage() {
  return (
    <ChatWidgetContextProvider>
      <div
        className="fixed inset-0 flex bg-white"
        style={{
          top: '65px',
          zIndex: 1,
          '--chat-font-size': '16px',
          '--chat-font-size-sm': '14px',
          '--chat-font-size-xs': '13px',
        } as React.CSSProperties}
        data-testid="llm-chat-page"
      >
        <div
          className="flex-shrink-0 border-r border-gray-200 bg-gray-50"
          style={{ width: '260px' }}
        >
          <ConversationsSidebar />
        </div>
        <ConversationArea />
      </div>
    </ChatWidgetContextProvider>
  );
}
